import { GetUserProfileAdminResponseModel, UserPersonalInfoResponseModel } from "@payping/api";
import { atom } from "jotai";

interface SettingsPersonalAtom {
  mobileFormEdit: Omit<UserPersonalInfoResponseModel, "verifyType"> &
    Omit<GetUserProfileAdminResponseModel, "verifyType"> &
    NonNullable<unknown>;
}
export const settingsPersonalAtom = atom<SettingsPersonalAtom>({
  mobileFormEdit: {
    firstName: undefined,
    lastName: undefined,
    nationalCode: undefined,
    birthDate: undefined,
    phoneNumber: undefined,
    birthCertificateNumber: undefined,
    fatherName: undefined,
    email: undefined,
    documents: undefined,
  },
});
